import type { Uatraits } from '@yandex-int/k-common';

import * as constants from './constants';

export const setUatraits = (uatraits: Uatraits) => {
    return { type: constants.SET_UATRAITS, uatraits } as const;
};
